import { reportWebVitalsMetrics } from '../helpers/performance.js';

export default function () {
    reportWebVitalsMetrics();
}
